import { GetStaticProps } from 'next';

import { TeamPageDocument, TeamPageQuery } from 'graphql/generated';

import ContentBoxNew from 'components/ContentBoxNew';
import DatoMeta from 'components/DatoMeta';
import DatoStructuredText from 'components/DatoStructuredText';
import Footer from 'components/Footer';
import Navigation from 'components/Navigation';
import RootContainer from 'components/RootContainer';
import TeammateBox from 'components/TeammateBox';

import { datoRequest } from 'lib/datoSDK';

import * as S from 'styles/Team.styles';

interface ITeamProps {
  teamPageQuery: TeamPageQuery;
}
const Team = ({ teamPageQuery }: ITeamProps) => {
  const seo = teamPageQuery.teamPage?.seo;
  const contentBoxes = teamPageQuery.teamPage?.content;
  const teamMembers = teamPageQuery.allTeamMembers;

  return (
    <>
      {seo && <DatoMeta seo={seo} />}

      <Navigation navItems={teamPageQuery.allNavitems} />

      <RootContainer>
        {contentBoxes?.map((contentBox, i) => (
          <ContentBoxNew
            key={i}
            leftImageSrc={contentBox.leftImage?.url}
            rightImageSrc={contentBox.rightImage?.url}
          >
            <DatoStructuredText data={contentBox.content} />
          </ContentBoxNew>
        ))}

        <S.TeamBlock>
          {teamMembers
            .filter((teamMember) => teamMember.appearOnFirstLine)
            .map((teamMember, index) => (
              <TeammateBox
                key={index}
                name={teamMember.name}
                imageSrc={teamMember.image.url}
                position={teamMember.workPosition}
              />
            ))}
        </S.TeamBlock>

        <S.TeamBlock>
          {teamMembers
            .filter((teamMember) => !teamMember.appearOnFirstLine)
            .map((teamMember, index) => (
              <TeammateBox
                key={index}
                name={teamMember.name}
                imageSrc={teamMember.image.url}
                position={teamMember.workPosition}
              />
            ))}
        </S.TeamBlock>
      </RootContainer>

      <Footer />
    </>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  const teamPageQuery = await datoRequest<TeamPageQuery>(TeamPageDocument);

  return {
    props: { teamPageQuery },
    revalidate: 1
  };
};

export default Team;
